import React from 'react';
import ConnectionContext from './ConnectionContext';

export const useConnection = () => {
  return React.useContext(ConnectionContext);
};
